export default __webpack_public_path__ + "static/drukarki_dzierzawa_l4266-e8018346e77f07caae5268d0a963d65e.png";